const copy = {
  preChat: {
    headerText: (name?: string) =>
      `Hi${name ? " " + name : ""}, how can I help?`,
    secondaryHeaderText: "Ask our Sales Co-Pilot!",
  },
};

export default copy;
